export const maxContactsCount = 15
export const maxBillingAddressesCount = 20
export const maxShippingAddressesCount = 20
export const maxUccAddressesCount = 20
